export default __webpack_public_path__ + "static/Laboratorio-a05e62c7fa12dac65a1c7656e629a26e.jpg";